var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('VRow',[_c('VSpacer'),_c('VSkeletonLoader',{attrs:{"type":"actions"}})],1),_c('VRow',[_c('VCol',{attrs:{"cols":"12"}},_vm._l((6),function(_,index){return _c('VSkeletonLoader',{key:`loader-${index}`,staticClass:"mb-2 py-2",attrs:{"type":"text"}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }